<template>
  <v-alert type="info" dense class="text-left" rounded text outlined>
    {{ $t('delivery.mode.estimatedTime', {hour: hour}) }}
  </v-alert>
</template>

<script>
import CalendarIsActive from "@/modules/calendar/mixins/CalendarIsActive";

export default  {
  name: "ScheduleAsSoonAsPosible",
  mixins: [CalendarIsActive],
  props: {
    value: {type: String},
    enableDeliveryTime: {type: Boolean, default: false}
  },
  data() {
    return {
      interval: null
    }
  },
  mounted() {
    this.setTime()
    this.interval = setInterval(this.setTime, 10000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    setTime() {
      this.$nextTick(() => {
       this.hour = this.$store.getters.orderSystem.getAsSoonAsPosible
      })
    }
  },
  computed: {
    hour: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style scoped>

</style>
